import { dataProps } from './properties'

export const setDocumentList = (state, payload) => {
    state.props = []
    let key = 0
    payload.forEach(element => {
        element.key = key
        if(payload.copy) {
            element.id = 0
        }
        state.props.push(element)
        key ++
    })    
}

export const addNewDocumentRow = state => {

    let key = 0
    state.props.push(JSON.parse(JSON.stringify(dataProps)))

    state.props.forEach(element => {
        element.key = key
        key ++
    })
    setTimeout(() => {
        document.getElementById('document_title_'+(key-1)).focus()
    }, 300);

}

export const removeDocumentRow = (state, payload) => {

    let key = 0

    state.deletedItems.push(state.props[payload])

    state.props.splice(payload, 1)

    state.props.forEach(element => {
        element.key = key
        key ++
    })

    
}

export const resetDocumentList = state => {
    state.props = []
}


// WEBPACK FOOTER //
// ./src/store/modules/document/mutations.js